import { useCallback, useEffect, useState } from "react";

import { fetchTrdxSaleSnapshot } from "../services/web3/trdxSaleDisplay";

const INITIAL = {
  loading: true,
  envConfigured: false,
  publicStatus: "config_missing",
  statusLabel: "Configuration pending",
  walletPurchaseEnabled: false,
  paused: false,
  hasInventory: false,
  inventoryWei: null,
  tokensPerEthWei: null,
  pricePerTrdxUsdcWei: null,
};

/**
 * Polls on-chain TreydorexSale state for public UI (read-only).
 * @param {{ refreshMs?: number, enabled?: boolean }} [options]
 */
export function useTrdxSaleSnapshot(options = {}) {
  const { refreshMs = 60_000, enabled = true } = options;
  const [snapshot, setSnapshot] = useState(INITIAL);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    setSnapshot((prev) => ({ ...prev, loading: true }));
    const next = await fetchTrdxSaleSnapshot();
    setSnapshot({ ...next, loading: false });
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return undefined;
    refresh();
    if (!refreshMs || refreshMs <= 0) return undefined;
    const id = setInterval(refresh, refreshMs);
    return () => clearInterval(id);
  }, [enabled, refresh, refreshMs]);

  return { ...snapshot, refresh };
}
